import { Table } from '@mantine/core';
import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { Fragment } from 'react/jsx-runtime';
import { useTranslation } from 'react-i18next';
import { gameModel } from 'entities/game';
import { getBetHistoryQuery } from 'shared/api';
import { useBreakpoint, useHasScroll } from 'shared/lib';
import { NumberFormatter } from 'shared/ui';
import { calcTimeBet } from '../../lib';
import { myBetsModalModel } from '../../model';
import cls from './my-bets-modal-table.module.scss';

export const MyBetsModalTable = () => {
	const { t } = useTranslation();

	const [bets, currency, pending] = useUnit([
		myBetsModalModel.$bets,
		gameModel.$currency,
		getBetHistoryQuery.$pending,
	]);

	const sm = useBreakpoint('sm', false);
	const { ref, isHas } = useHasScroll([bets]);

	const isLoading = bets === null && pending;
	const isEmpty = bets?.length === 0;

	useEffect(() => {
		bets && ref.current?.scrollTo({ top: 0 });
	}, [bets]);

	if (isLoading)
		return <div className={cls.myBetsModalTableMessage}>{t('my-bets-modal.loading')}</div>;

	if (isEmpty) return <div className={cls.myBetsModalTableMessage}>{t('my-bets-modal.empty')}</div>;

	const rows = bets?.map((group) => (
		<Fragment key={group.date}>
			<Table.Tr>
				<Table.Td
					colSpan={5}
					className={clsx(cls.myBetsModalTableDate, 'native')}
				>
					{group.date}
				</Table.Td>
			</Table.Tr>
			{group.rows.map((bet) => (
				<Table.Tr key={`${bet.time}`}>
					<Table.Td className='native'>{calcTimeBet(bet.time)}</Table.Td>
					<Table.Td>
						<NumberFormatter value={bet.bet} />
					</Table.Td>
					<Table.Td>
						<NumberFormatter value={bet.multiplier} />
						{t('multiplier')}
					</Table.Td>
					<Table.Td className={cls.myBetsModalTableWin}>
						<NumberFormatter value={bet.profit} />
					</Table.Td>
					<Table.Td className='native'>{currency}</Table.Td>
				</Table.Tr>
			))}
		</Fragment>
	));

	return (
		<div
			ref={ref}
			className={cls.myBetsModalTable}
			data-scroll={isHas || undefined}
		>
			<div>
				<Table
					size={sm ? 'md' : 'sm'}
					className={cls.myBetsModalTableTable}
				>
					<colgroup>
						<col />
						<col />
						<col />
						<col />
						<col />
					</colgroup>
					<Table.Thead>
						<Table.Tr>
							<Table.Th>{t('my-bets-modal.time')}</Table.Th>
							<Table.Th>{t('my-bets-modal.bet')}</Table.Th>
							<Table.Th>{t('my-bets-modal.odds')}</Table.Th>
							<Table.Th>{t('my-bets-modal.win')}</Table.Th>
							<Table.Th>{t('my-bets-modal.currency')}</Table.Th>
						</Table.Tr>
					</Table.Thead>
					<Table.Tbody>{rows}</Table.Tbody>
				</Table>
			</div>
		</div>
	);
};
